 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_cover'
 import HTML01_TITLEPAGE from '@/components/html/01_titlepage'
 import HTML02_COPYRIGHTPAGE from '@/components/html/02_copyrightpage'
 import HTML03_ABOUT_THE_AUTHOR from '@/components/html/03_about_the_author'
 import HTML04_CONTENTS from '@/components/html/04_contents'
 import HTML05_LIST_OF_TABLES from '@/components/html/05_list_of_tables'
 import HTML06_FIGURES from '@/components/html/06_figures'
 import HTML07_CHAP1 from '@/components/html/07_chap1'
 import HTML08_CHAP2 from '@/components/html/08_chap2'
 import HTML09_CHAP3 from '@/components/html/09_chap3'
 import HTML10_CHAP4 from '@/components/html/10_chap4'
 import HTML11_CHAP5 from '@/components/html/11_chap5'
 import HTML12_CHAP6 from '@/components/html/12_chap6'
 import HTML13_CHAP7 from '@/components/html/13_chap7'
 import HTML14_CHAP8 from '@/components/html/14_chap8'
 import HTML15_CHAP9 from '@/components/html/15_chap9'
 import HTML16_CHAP10 from '@/components/html/16_chap10'
 import HTML17_CHAP11 from '@/components/html/17_chap11'
 import HTML18_CHAP12 from '@/components/html/18_chap12'
 import HTML19_CHAP13 from '@/components/html/19_chap13'
 import HTML20_GLOSSARY from '@/components/html/20_glossary'
 import HTML21_BIBLIOGRAPHY from '@/components/html/21_bibliography'
 import HTML22_CONTACT from '@/components/html/22_contact'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_contents",
 			"name" : "html/04_contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_list_of_tables",
 			"name" : "html/05_list_of_tables",
 			"component" : HTML05_LIST_OF_TABLES
 		},
 		{
 			"path" : "/html/06_figures",
 			"name" : "html/06_figures",
 			"component" : HTML06_FIGURES
 		},
 		{
 			"path" : "/html/07_chap1",
 			"name" : "html/07_chap1",
 			"component" : HTML07_CHAP1
 		},
 		{
 			"path" : "/html/08_chap2",
 			"name" : "html/08_chap2",
 			"component" : HTML08_CHAP2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js